/**
 * The client list's two restored filters (RESTORE_PLAN R3.4, from the old
 * ConsultantPanel's client table): "Active SOWs only" and "My clients". A row
 * is one engagement (PRD §4.7); `/consultant/engagements` carries the fields read here.
 */

export interface ClientRowLike {
  status?: string | null;
  activeChangeOrderCount?: number | null;
  engagementLeadId?: string | null;
  engagementCreatedBy?: string | null;
  companyOwnerId?: string | null;
  companyCreatedBy?: string | null;
  assignedConsultants?: unknown[] | null;
}

export interface ClientListFilters {
  activeOnly: boolean;
  mineOnly: boolean;
}

/** The SOW is active, or a change order is open on it (the old filter counted both). */
export function isActiveSow(row: ClientRowLike): boolean {
  return String(row.status ?? '').toLowerCase() === 'active' || Number(row.activeChangeOrderCount ?? 0) > 0;
}

/** The viewer owns or created the client, leads or created the engagement, or is assigned to it. */
export function isMyClient(row: ClientRowLike, userId: string | null | undefined): boolean {
  if (!userId) return false;
  if ([row.companyOwnerId, row.companyCreatedBy, row.engagementLeadId, row.engagementCreatedBy].includes(userId)) return true;
  return (row.assignedConsultants ?? []).some((a: any) => a === userId || a?.id === userId || a?.userId === userId);
}

export function applyClientListFilters<T extends ClientRowLike>(rows: T[], f: ClientListFilters, userId: string | null | undefined): T[] {
  return rows.filter((r) => (!f.activeOnly || isActiveSow(r)) && (!f.mineOnly || isMyClient(r, userId)));
}

/** BD reps start on their own clients, as the old list did; everyone else on all. */
export function defaultMineOnly(user: any): boolean {
  const roles: unknown[] = Array.isArray(user?.roles) && user.roles.length ? user.roles : [user?.role];
  return roles.some((r) => r === 'bdRep' || r === 'bd_rep');
}
